export enum RoomType {
	ACCOMMODATE_TO_OCCUPIED_ROOM = 'DOK',
	ACCOMMODATE_WOMEN_TO_OCCUPIED_ROOM = 'DOK-K',
	APARTMENT_FOR_THREE = 'AP3',
	APARTMENT_FOR_THREE_WITH_BONUS_BED = 'A31',
	APARTMENT_FOR_FOUR = 'AP4',
	APARTMENT_FOR_FOUR_WITH_BONUS_BED = 'A41',
	APARTMENT_FOR_FOUR_WITH_TWO_BONUS_SEPARATE_BEDS = 'A42',
	APARTMENT_FOR_FOUR_WITH_TWO_BONUS_BEDS = 'A4S',
	APARTMENT_FOR_FIVE = 'AP5',
	APARTMENT_FOR_FIVE_WITH_BONUS_BED = 'A51',
	APARTMENT_FOR_SIX = 'AP6',
	SINGLE_ROOM = 'SGL',
	ROOM_FOR_TWO = 'DBL',
	ROOM_FOR_TWO_WITH_BONUS_BED = 'DB1',
	ROOM_FOR_TWO_WITH_BONUS_BED_AND_SEA_VIEW = 'D1V',
	ROOM_FOR_TWO_WITH_TWO_BONUS_BEDS = 'DB2',
	ROOM_FOR_TWO_WITH_SEPARATE_BEDS = 'TWN',
	ROOM_FOR_TWO_WITH_TERRACE = 'DBT',
	ROOM_FOR_TWO_WITH_SEA_VIEW = 'DSV',
	ROOM_FOR_THREE = 'TRP',
	ROOM_FOR_THREE_WITH_SEPARATE_BEDS = 'TPT',
	ROOM_FOR_FOUR_WITH_ONE_DOUBLE_BED_AND_TWO_SINGLE = 'QTT',
	ROOM_FOR_FOUR_WITH_TWO_DOUBLE_BEDS = 'QTR',
	STUDIO_FOR_ONE = 'ST1',
	STUDIO_FOR_TWO = 'ST2',
	STUDIO_FOR_TWO_WITH_BONUS_BED = 'S21',
	STUDIO_FOR_TWO_WITH_SEPARATE_BEDS = 'S2T',
	STUDIO_FOR_TWO_SHARED_TERRACE = 'S2W',
	STUDIO_FOR_THREE = 'ST3',
	STUDIO_FOR_THREE_WITH_BONUS_BED = 'S31',
	STUDIO_FOR_THREE_WITH_SEPARATE_BEDS = 'S3T',
	STUDIO_FOR_FOUR = 'ST4',
}

export const PlaceForSingle = [
	RoomType.SINGLE_ROOM,
	RoomType.STUDIO_FOR_ONE,
	RoomType.ACCOMMODATE_TO_OCCUPIED_ROOM,
	RoomType.ACCOMMODATE_WOMEN_TO_OCCUPIED_ROOM,
];
export const PlaceForTwo = [
	RoomType.STUDIO_FOR_TWO,
	RoomType.ROOM_FOR_TWO,
	RoomType.ROOM_FOR_TWO_WITH_TERRACE,
	RoomType.ROOM_FOR_TWO_WITH_SEA_VIEW,
	RoomType.ROOM_FOR_TWO_WITH_SEPARATE_BEDS,
	RoomType.STUDIO_FOR_TWO_SHARED_TERRACE,
	RoomType.STUDIO_FOR_TWO_WITH_SEPARATE_BEDS,
];

export const PlaceForThree = [
	RoomType.APARTMENT_FOR_THREE,
	RoomType.ROOM_FOR_TWO_WITH_BONUS_BED,
	RoomType.ROOM_FOR_TWO_WITH_BONUS_BED_AND_SEA_VIEW,
	RoomType.ROOM_FOR_THREE,
	RoomType.ROOM_FOR_THREE_WITH_SEPARATE_BEDS,
	RoomType.STUDIO_FOR_TWO_WITH_BONUS_BED,
	RoomType.STUDIO_FOR_THREE,
	RoomType.STUDIO_FOR_THREE_WITH_SEPARATE_BEDS,
];

export const PlaceForFour = [
	RoomType.APARTMENT_FOR_FOUR,
	RoomType.APARTMENT_FOR_THREE_WITH_BONUS_BED,
	RoomType.ROOM_FOR_FOUR_WITH_TWO_DOUBLE_BEDS,
	RoomType.ROOM_FOR_FOUR_WITH_ONE_DOUBLE_BED_AND_TWO_SINGLE,
	RoomType.STUDIO_FOR_THREE_WITH_BONUS_BED,
	RoomType.STUDIO_FOR_FOUR,
	RoomType.ROOM_FOR_TWO_WITH_TWO_BONUS_BEDS,
];

export const PlaceForFive = [RoomType.APARTMENT_FOR_FIVE, RoomType.APARTMENT_FOR_FOUR_WITH_BONUS_BED];

export const PlaceForSix = [
	RoomType.APARTMENT_FOR_FOUR_WITH_TWO_BONUS_SEPARATE_BEDS,
	RoomType.APARTMENT_FOR_FOUR_WITH_TWO_BONUS_BEDS,
	RoomType.APARTMENT_FOR_FIVE_WITH_BONUS_BED,
	RoomType.APARTMENT_FOR_SIX,
];
